const addClassNamesToBody = (elem, list) => {
    if (typeof list === "string") list = list.split(" ");
    for (var i = 0; i < list.length; i++) {
        elem.classList.add(list[i]);
    }
};

const removeClassNamesFromBody = (elem, list) => {
    if (typeof list === "string") list = list.split(" ");
    for (var i = 0; i < list.length; i++) {
        elem.classList.remove(list[i]);
    }
};

const classNameExistsInBody = (className: string) => document.body.classList.contains(className);

const getCssList = (value) => {
    var list = [];
    if (!value) return list;
    list.push("theme-" + value);
    if (value.startsWith("bs-")) list.push("theme-bs");
    if (value.startsWith("bd-")) list.push("theme-bd");
    if (value.endsWith("-default")) list.push("theme-light");
    if (value.endsWith("-light")) list.push("theme-light");
    if (value.endsWith("-dark")) list.push("theme-dark");
    return list;
};

/***********************/
export const helper = {
    getTheme: () => localStorage.getItem("bd-theme"),

    setTheme: (value) => {
        if (!value) value = "bd-quartz-light";
        localStorage.setItem("bd-theme", value);
        //
        var lst = [];
        var cl = document.body.classList;
        for (var i = 0; i < cl.length; i++) {
            if (cl[i].startsWith("theme-")) lst.push(cl[i]);
        }
        removeClassNamesFromBody(document.body, lst);
        var css_list = getCssList(value);
        addClassNamesToBody(document.body, css_list);
    },

    isDarkMode: () => {
        var t = helper.getTheme();
        return !!t && t.indexOf("dark") >= 0;
    },

    isRTL: () => classNameExistsInBody("rtl"),
    getRTL: () => localStorage.getItem("bd-dir") == "rtl",
    setRTL: (value) => {
        const css = value ? "rtl" : "ltr";
        localStorage.setItem("bd-dir", css);
        removeClassNamesFromBody(document.body, value ? "ltr" : "rtl");
        addClassNamesToBody(document.body, css);
    },
};

/***********************/
var t = helper.getTheme();
helper.setTheme(!t ? "bd-quartz-light" : t);
helper.setRTL(helper.getRTL());
